export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8375.2320e1e0.jpg";